export const generateImgSrc = (w, h, bgcolor = '#ccc') => {
  return 'data:image/svg+xml,'
    + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="' + w + 'px" height="' + h + 'px">'
      + '<rect x="0" y="0" width="100%" height="100%" fill="' + bgcolor + '"/>'
      + '</svg>');
}


// WEBPACK FOOTER //
// ./src/share/utils/generateImgSrc.ts